import { IAddress } from "@Interfaces/Api/user";
import { checkoutTypes } from "@Interfaces/Helper";
import { getCookie } from "cookies-next";
import { NextPageContext } from "next";
import moment from "moment";

export function isEmpty(obj: object) {
  return Object.keys(obj).length === 0;
}

export const isImage = (fileType: string) => {
  if (!fileType) return false;
  if (!fileType.match(/.(jpg|jpeg|png|gif|svg|webp)$/i)) return false;
  else return true;
};

export function storeObjectInLocalStrage(name: string, obj: Record<any, any>) {
  const data = JSON.stringify(obj);
  localStorage.setItem(name, data);
}

export function proceedToCheckoutHandler(cartId: string) {
  const obj = {
    type: checkoutTypes.CART,
    cartId,
  };
  storeObjectInLocalStrage("checkoutDetails", obj);
}
export function buyNowHandler(productId: string) {
  const obj = {
    type: checkoutTypes.PRODUCT,
    productId,
  };
  storeObjectInLocalStrage("checkoutDetails", obj);
}

export function getAddressString(address: IAddress) {
  return `${address?.line1}, ${address?.line2}, ${address?.city}, ${address?.state}, ${address?.zipCode}`;
}

export function dateToFromNowDaily(myDate: string) {
  // get from-now for this date
  var fromNow = moment(myDate).fromNow();

  // ensure the date is displayed with today and yesterday
  return moment(myDate).calendar(null, {
    // when the date is closer, specify custom values
    lastWeek: "[Last] dddd",
    lastDay: "[Yesterday]",
    sameDay: "[Today]",
    nextDay: "[Tomorrow]",
    nextWeek: "dddd",
    // when the date is further away, use from-now functionality
    sameElse: function () {
      return "[" + fromNow + "]";
    },
  });
}
export function getArrayOfGivenLength(arrayLength: number) {
  const array = [];
  for (let i = 0; i < arrayLength; i++) {
    array.push(i);
  }
  return array;
}

// Protected Routes

export function checkLoggedIn(ctx: any, redirectTo: string) {
  const { req, res } = ctx;
  const isLoggedIn = getCookie("userId", { req, res });
  if (!isLoggedIn) {
    return {
      redirect: {
        destination: `/${redirectTo}`,
        permanent: false,
      },
    };
  }

  return null;
}
